'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionAlerts', ['$scope', function ($scope) {
        $scope.resetInspection();
        $scope.columns = [
            {
                label: 'Alert Type',
                field: 'alert_type.name',
                link: {
                    state: 'internal.inspecting.inspection.alert',
                    params: [
                        {
                            name: 'inspectionAlertID',
                            field: 'id'
                        },
                        {
                            name: 'inspection_alert',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Message',
                field: 'message_display'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];

        $scope.filters = [
            {
                name: 'Alert Type',
                field: 'alert_type_id',
                service: 'AlertTypes'
            },
            {
                name: 'Retired',
                field: 'retired',
                options: [
                    { name: 'No', id: false },
                    { name: 'Yes', id: true }
                ]
            }
        ];
    }])
;